import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client, RoleCrud } from '../../../../api/api-reference';

@Component({
  selector: 'app-role-information',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule],
  templateUrl: './role-information.component.html',
  styleUrl: './role-information.component.scss',
})
export class RoleInformationComponent implements OnInit {
  @Input() id: string = '';
  @Output() close = new EventEmitter<boolean>();
  role: RoleCrud = new RoleCrud();

  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getRoleById();
  }

  toggleModal() {
    this.close.emit();
  }

  getRoleById() {
    this.client.getRole(this.id).subscribe({
      next: (response) => {
        this.role = response;
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  formatPermission(permission: string): string {
    return permission
      .split('_') // Splits the string by underscores
      .slice(1) // Removes the first word from the array
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalizes the first letter of each word
      .join(' '); // Joins the words back together with spaces
  }
}
